<template>
    <div class="wrap-content system-users-section">
        <div class="filter-section row-min-space">
            <div class="row">
                <div class="col-md-12">
                    <h2>System Users</h2>
                </div>

                <div class="col-md-12 ">
                    <div class="row">
                        <div class="col-xs-12 col-md-9">
                            <div class="row">
                                <div class="col-xs-12 col-md-3">
                                    <div class="form-group search-input">
                                        <i class="icon-search"></i>
                                        <b-form-input
                                            v-model="query.keyword"
                                            :placeholder="'Search'"
                                            autocomplete="no"
                                            @keyup.enter="applySearch('search')"
                                        ></b-form-input>
                                    </div>
                                </div>
                                <div class="col-xs-12 col-md-3">
                                    <b-form-group>
                                        <b-form-select
                                            id="user_role"
                                            v-model="query.roleId"
                                            class="form-control"
                                            :options="roles"
                                        ></b-form-select>
                                    </b-form-group>
                                </div>
                                <div class="col-xs-12 col-md-3">
                                    <b-form-group>
                                        <b-form-select
                                            id="user_data_segments"
                                            v-model="query.dataSegmentId"
                                            class="form-control"
                                            :options="dataSegmentsOptionList"
                                        ></b-form-select>
                                    </b-form-group>
                                </div>
                                <div class="col-xs-12 col-md-3">
                                    <b-form-group>
                                        <b-form-select
                                            id="input-3"
                                            v-model="query.status"
                                            class="form-control"
                                            :options="filterByStatusOption"
                                        ></b-form-select>
                                    </b-form-group>
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-12 col-md-3">
                            <div class="row">
                                <div class="col-xs-12 col-md-5">
                                    <button
                                        class="btn btn-primary"
                                        type="submit"
                                        :class="
                                            loading && showPageLoader
                                                ? 'disabled'
                                                : ''
                                        "
                                        @click="applySearch('search')"
                                    >
                                        <span class="btn-text">Apply</span>
                                        <span class="loader"></span>
                                    </button>
                                </div>
                                <div class="col-xs-12 col-md-7">
                                    <b-button
                                        v-b-modal.add-system-user-popup
                                        class="btn secondary-add-btn"
                                        variant="secondary"
                                        type="submit"
                                        :class="
                                            hasScopes('manage-system-users')
                                                ? ''
                                                : 'button-disabled'
                                        "
                                    >
                                        <span class="btn-text">+ Add User</span>
                                    </b-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- user management table -->
        <div
            :class="[
                'table-section',
                'table-min-width',
                'mobile-table-responsive',
                'user-table',
                {
                    'overflow-hidden': !items.length && !showPageLoader,
                },
            ]"
        >
            <b-table
                :items="items"
                :fields="systemUsersfieldsList"
                :tbody-tr-class="disableLoggedInUser"
                no-local-sorting
                @sort-changed="sortingChanged"
            >
                <!-- User Profile -->
                <template slot="profile" slot-scope="data">
                    <div class="profile-area customer-link profile-img">
                        <div
                            v-if="!data.item.avatar"
                            class="profile-pic"
                            :style="{
                                'background-image':
                                    'url(' +
                                    require('@/assets/images/dummy/dummy-user.png') +
                                    ')',
                            }"
                        ></div>
                        <div
                            v-if="data.item.avatar"
                            v-authenticated-image="imageFilePath(data.item)"
                            class="profile-pic"
                        ></div>
                    </div>
                </template>

                <!-- User Data -->
                <template slot="firstName" slot-scope="data">
                    <div class="profile-area customer-link profile-name">
                        {{ data.item.firstName + ' ' + data.item.lastName }}
                    </div>
                </template>

                <!-- Role Data  -->
                <template slot="role" slot-scope="data">
                    <div class="customer-link">
                        <span>{{ data.item.role.title }}</span>
                    </div>
                </template>

                <!-- Data Segments  -->
                <template slot="data_segments" slot-scope="data">
                    <div class="customer-link">
                        <span v-if="data.item.dataSegments.length == 0"
                            >All</span
                        >
                        <span
                            v-for="(segment, index) in data.item.dataSegments"
                            :key="index"
                        >
                            <span>
                                {{ segment.code
                                }}<span
                                    v-if="
                                        index !=
                                            data.item.dataSegments.length - 1
                                    "
                                    >,</span
                                >
                            </span>
                        </span>
                    </div>
                </template>

                <!-- Join Date -->
                <template slot="createdAt" slot-scope="data">
                    {{ data.item.createdAt | moment('MMM D, YYYY h:mm a') }}
                </template>

                <!-- status slot -->
                <template slot="status" slot-scope="data">
                    <base-status :status-type="data.item.status"> </base-status>
                </template>

                <!-- Action Slot -->
                <template slot="action" slot-scope="data">
                    <div
                        :class="[
                            'action-review',
                            {
                                disabled:
                                    data.item.status == 'pending' ||
                                    !hasScopes('manage-system-users'),
                            },
                        ]"
                    >
                        <base-action
                            icon="icon-edit"
                            label="Modify"
                            @click="
                                selectedRecord(data.item)
                                $bvModal.show('add-system-user-popup')
                            "
                        ></base-action>
                        <base-action
                            v-if="
                                data.item.status == 'active' ||
                                    data.item.status == 'pending'
                            "
                            icon="icon-trash"
                            label="Archive"
                            @click="
                                selectedRecord(data.item)
                                $bvModal.show('archive-popup')
                            "
                        ></base-action>
                        <base-action
                            v-if="data.item.status == 'archived'"
                            icon="icon-done"
                            label="Activate"
                            @click="
                                selectedRecord(data.item)
                                $bvModal.show('activate-popup')
                            "
                        ></base-action>
                    </div>
                </template>
            </b-table>
            <base-table-spinner
                v-if="!items.length && showPageLoader"
            ></base-table-spinner>
            <!-- When record not found -->
            <base-no-record-found
                v-if="!items.length && !showPageLoader"
            ></base-no-record-found>
        </div>

        <pagination
            v-if="!showPageLoader"
            :pagination="pagination"
            @pagination-changed="paginationChanged"
            @button-clicked-previous="applySearch('previous')"
            @button-clicked-next="applySearch('next')"
        ></pagination>

        <add-system-user-popup></add-system-user-popup>
        <archive-popup
            ref="archive-popup"
            record-type="system_user"
            @update-status="updateStatus"
        ></archive-popup>
        <activate-popup
            ref="activate-popup"
            record-type="system_user"
            @update-status="updateStatus"
        ></activate-popup>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import pagination from '@/components/Pagination.vue'
import addSystemUserPopup from '@/components/popups/AddSystemUserPopup.vue'
import archivePopup from '@/components/popups/ArchivePopup.vue'
import activatePopup from '@/components/popups/ActivatePopup.vue'
import resource from '@/api/resource'

const userResource = new resource('system-users/')
const roleApi = new resource('access-control/roles')
const dataSegmentApi = new resource('access-control/data-segments')

export default {
    components: {
        pagination,
        addSystemUserPopup,
        archivePopup,
        activatePopup,
    },

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */

    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            image: 'dummy/dummy-user.png',

            // Page loader

            // System user listing variables
            query: {
                startAt: 1,
                keyword: '',
                perPage: 10,
                roleId: null,
                dataSegmentId: null,
                status: null,
            },

            // System user pagination
            pagination: {},

            // System user table fields
            systemUsersfieldsList: [],

            items: [],
            // Dropdown role options list
            roles: [{ value: null, text: 'Filter by user roles' }],
            // Dropdown data segments option list
            dataSegmentsOptionList: [
                { value: null, text: 'Filter by data segments' },
            ],
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters([
            'loading',
            'reload',
            'selectedItem',
            'systemUsersfields',
            'filterByStatusOption',
            'userId',
            'showPageLoader',
            'hasScopes',
        ]),
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        reload(value) {
            if (value) {
                this.items = []
                this.query.startAt = 1
                this.getRecords()
            }
        },
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */

    mounted() {
        // Load System user list
        this.getRecords()

        // Load options of Data Segment and Roles
        this.getOptionsList()
    }, // End of Component > watch

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        disableLoggedInUser(item) {
            if (!item) return
            if (item._id === this.userId) return 'disable-row'
        },
        paginationChanged(type) {
            const perPage = type || 10
            this.query.perPage = perPage
            this.query.startAt = 1
            this.getRecords()
        }, // End of paginationChanged() method

        //apply filters and get matching records
        applySearch(type) {
            if (type && type == 'next') {
                this.query.startAt = this.pagination.next
            }

            if (type && type == 'previous') {
                this.query.startAt = this.pagination.current - 1
            }

            if (type && type == 'search') {
                this.query.startAt = 1
            }

            this.items = []
            if (type && type == 'search') {
                this.$store.commit('setLoading', true)
            }
            this.$store.commit('showPageLoader', true)
            this.getRecords()
        }, // End of applySearch() method

        async getRecords() {
            // Get Fields list from mapGetters (store)
            this.systemUsersfieldsList = this.systemUsersfields
            this.$store.commit('showPageLoader', true)
            let { data } = await userResource.list(this.query)
            if (data && data.data) {
                if (data.data.length) {
                    // Get all data in items
                    this.items = data.data
                    await this.$store.commit('setUsersList', data.data)
                }

                if (data.pagination) {
                    let pagination = data.pagination
                    this.pagination = pagination
                    // Show Pagination
                    this.query.startAt = pagination.current
                    this.pagination.perPage = this.query.perPage
                    this.pagination.totalRecords = data.data.length
                }
            }

            // False the page loader after the list has been loaded
            this.$store.commit('showPageLoader', false)
            this.$store.commit('setLoading', false)
        },
        // End of getRecords() method

        async updateStatus(status) {
            let params = {
                id: this.selectedItem._id,
                changeStatus: true,
                status: status,
                username: this.selectedItem.username,
                firstName: this.selectedItem.firstName,
                lastName: this.selectedItem.lastName,
                email: this.selectedItem.email,
                roleId: this.selectedItem.roleId,
                dataSegmentIds: this.selectedItem.dataSegmentIds,
            }

            await this.$store.dispatch('updateSystemUser', params)
        }, // End of updateStatus() method

        // List Sorting
        sortingChanged(ctx) {
            // ctx.sortBy   ==> Field key for sorting by (or null for no sorting)

            this.query.sortBy = ctx.sortBy
            if (ctx.sortBy == 'data_segments') {
                this.query.sortBy = 'dataSegments.title'
            }
            // ctx.sortDesc ==> true if sorting descending, false otherwise
            this.query.sortOrder = ctx.sortDesc ? 'desc' : 'asc'

            this.getRecords()
        }, // End of sortingChanged() method

        // set the record values to be updated
        selectedRecord(record) {
            this.$store.commit('setItem', record)
        },
        // End of selectedRecord() method

        async getOptionsList() {
            let self = this
            // Data segments option list

            let dataSegmentList = await dataSegmentApi.list({
                ref: 'dropdown',
                perPage: 1000,
            })
            if (dataSegmentList.data && dataSegmentList.data.data) {
                self.dataSegmentsOptionList.push({
                    text: 'All',
                    value: 'all',
                })
                dataSegmentList.data.data.forEach(function(val) {
                    self.dataSegmentsOptionList.push({
                        text: val.code,
                        value: val._id,
                    })
                })
                localStorage.setItem(
                    'dataSegmentList',
                    JSON.stringify(dataSegmentList.data.data)
                )
            }

            // Roles option list
            let rolesList = await roleApi.list({ ref: 'dropdown' })
            if (rolesList.data && rolesList.data.data) {
                rolesList.data.data.forEach(function(val) {
                    self.roles.push({ text: val.title, value: val.id })
                })
                localStorage.setItem(
                    'rolesList',
                    JSON.stringify(rolesList.data.data)
                )
            }
        }, // End of getOptionsList() method
        imageFilePath(data) {
            if (data && data.avatar) {
                return 'users/' + data.avatar.fileName
            }
            return require('@/assets/images/dummy/dummy-user.png')
        },
    }, // End of Component > mounted
} // End of export default
</script>
